module.exports = "https://static.zego.com/_next/static/images/FleetTrades-9bbb316b7a94fe880e70d4e40474c1cf.svg";